import React from "react";
import AmountsEz from "../../../assets/AmountsEz";
import King from "../../../assets/King";
import PlaceEz from "../../../assets/PlaceEz";
import RatesEz from "../../../assets/RatesEz";
import RightEz from "../../../assets/RightEz";
import SpeedEz from "../../../assets/SpeedEz";
import { useTranslations } from "next-intl";
export default function WhyEz() {
  const obj = [
    { id: 1, title: "Customer is King", svg: <King /> },
    { id: 2, title: "All Banks in one place", svg: <PlaceEz /> },
    { id: 3, title: "Speed", svg: <SpeedEz /> },
    { id: 4, title: "Higher Loans Amounts", svg: <AmountsEz /> },
    { id: 5, title: "Competitive Rates", svg: <RatesEz /> },
    { id: 6, title: "Right services", svg: <RightEz /> },
  ];
  const t = useTranslations("ez_credit.why_ez");
  return (
    <>
      <div className="py-[5rem] relative z-10 bg-[#C29D3E0D] bg-opacity-[5%]">
        <div
          style={{
            background: "#C29D3E2E",
            opacity: "0.82",
            filter: "blur(45px)",
          }}
          className="lg:h-[260px] lg:w-[260px] w-[223px] h-[215px] absolute lg:top-[15%] top-[20%] -z-10"
        ></div>
        <div
          style={{
            background: "#C29D3E2E",
            opacity: "0.83",
            filter: "blur(75.5px)",
          }}
          className="lg:h-[200px] lg:w-[200px] w-[116px] h-[111px] absolute lg:right-[30%] lg:top-[40%] bottom-0 right-0 -z-10"
        ></div>
        <div
          style={{
            background: "#C29D3E2E",
            opacity: "0.10",
            filter: "blur(60px)",
          }}
          className="h-[200px] hidden lg:block w-[200px] absolute lg:right-[5%] lg:top-[10%] -z-10"
        ></div>
        <div className="px-6  max-w-[90rem] responsive xl:mx-auto py-[3rem]">
          <div className="pb-[51px]">
            <p className=" font-[590] text-[40px]   leading-[56px] text-[#1D1D1B]">
              {t("header")}
            </p>
            <hr
              style={{
                background: "#C29D3E",
              }}
              className={`h-[5px] border-none rounded-[22.5px] w-[138px]`}
            ></hr>
          </div>

          <div className=" grid grid-cols-12  gap-5 my-[2rem]">
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <King />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideOne")}
                </p>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <PlaceEz />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideTwo")}
                </p>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <SpeedEz />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideThree")}
                </p>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <AmountsEz />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideFour")}
                </p>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <RatesEz />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideFive")}
                </p>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
              }}
              className="col-span-6 lg:col-span-2  m-auto lg:w-[180px] lg:h-[215px] w-full h-[160px] text-center lg:p-5 p-3 "
            >
              <div className=" grid justify-center items-center">
                <div className="text-center m-auto my-3">
                  <RightEz />
                </div>
                <p className="text-center  text-[#1D1D1B] leading-[26px] text-[18px] font-[400] m-auto lg:my-3">
                  {t("slides.slideSix")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
